import { createSelector } from '@reduxjs/toolkit'
import { selectors } from '@gocanvas/client'
const { formSelector, entriesSelector, sheetsSelector } = selectors

export const formLogoSelector = createSelector(formSelector, ({ logo }) => logo)

// TODO: These are copied from Builder and currently needed to 
// get Tables/Loops working correctly. They should either be moved to the Client
// OR the underlying Client code should be updated so that they aren't needed...
export const multiSectionIds = createSelector(sheetsSelector, sheets =>
  sheets.map(({ multi_section }) => multi_section)
)

export const primarySheetsSelector = createSelector(
  sheetsSelector,
  multiSectionIds,
  (sheets, multiSectionIds) =>
    sheets.filter(({ section_id }) => !multiSectionIds.includes(section_id))
)

export const subSheetsSelector = createSelector(
  sheetsSelector,
  multiSectionIds,
  (sheets, multiSectionIds) =>
    sheets.filter(({ section_id }) => multiSectionIds.includes(section_id))
)

export const combinedSheetSelector = createSelector(
  primarySheetsSelector,
  subSheetsSelector,
  (primarySheets, subSheets) => {
    return primarySheets.map(sheet => {
      return {
        ...sheet,
        subSheets: subSheets
          .filter(({ section_id }) => {
            return sheet.multi_section === section_id
          })
          .map(({ id }) => id),
      }
    })
  }
)
export const tableSheetEntriesSelector = createSelector(
  entriesSelector,
  combinedSheetSelector,
  (entries, combinedSheets) => {
    const loopSheets = combinedSheets.filter(sheet => sheet?.subSheets?.length)

    return loopSheets.reduce((subSheetEntriesOnly, sheet) => {
      const { id, subSheets } = sheet
      subSheets.forEach(subSheetId => {
        subSheetEntriesOnly.push(
          ...entries.filter(
            entry => entry.sheet_id == subSheetId || entry.sheet_id == id
          )
        )
      })
      return subSheetEntriesOnly
    }, [])
  }
)

// All of the other selectors are to ultimately get to this -- it's possible,
// likely even, that there are more efficient ways to get there.
export const nonTableEntriesSelector = createSelector(
  entriesSelector,
  tableSheetEntriesSelector,
  (entries, tableSheets) => {
    const sheetEntryGuids = tableSheets.map(({ guid }) => guid)

    return entries.filter(({ guid }) => !sheetEntryGuids.includes(guid))
  }
)